import {
  ColumnType,
  ExpectedRowTypes,
  TestHistoryProps,
  TestKitType,
} from "@/common/types";
import CardsForTable from "@/components/cards-for-table";
import Table from "@/components/table";
import { convertDateToString } from "@/utils/date.util";
import { useNavigate } from "react-router-dom";

const columns: ColumnType[] = [
  { field: "kit_id", headerName: "Kit ID" },
  {
    field: "assigned_doctor",
    headerName: "Doctor",
    render: (row) => (row as TestKitType).assigned_doctor?.name || "-",
  },
  {
    field: "created_at",
    headerName: "Created At",
    render: (row) =>
      convertDateToString((row as TestKitType).created_at) || "-",
  },
  {
    field: "updated_at",
    headerName: "Updated At",
    render: (row) =>
      convertDateToString((row as TestKitType).updated_at) || "-",
  },
];

const TestHistory: React.FC<TestHistoryProps> = ({ testKits }) => {
  const navigate = useNavigate();

  const handleRowClick = (
    e: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
    row: ExpectedRowTypes
  ) => {
    e.stopPropagation();
    e.preventDefault();
    if ("id" in row) {
      navigate(`/test/${row.id}`);
    }
  };

  return (
    <>
      {/* Desktop View */}
      <div className="hidden md:flex">
        <Table
          rows={testKits || []}
          columns={columns}
          onRowClick={(e, row) =>
            handleRowClick(
              e as React.MouseEvent<HTMLTableRowElement, MouseEvent>,
              row
            )
          }
        />
      </div>

      {/* Mobile View */}
      <div className="flex md:hidden">
        <CardsForTable
          rows={testKits || []}
          columns={columns}
          onRowClick={(e, row) =>
            handleRowClick(
              e as React.MouseEvent<HTMLTableRowElement, MouseEvent>,
              row
            )
          }
        />
      </div>
    </>
  );
};

export default TestHistory;
